// const uuid = require('uuid');
import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button, Modal } from 'react-bootstrap';
const uuid = require('uuid');

const _ = {
    cloneDeep:  require('lodash/cloneDeep'),
    isEqual:    require('lodash/isEqual'),
    find:       require('lodash/find'),
    filter:     require('lodash/filter'),
    map:        require('lodash/map'),
    without:    require('lodash/without'),
};

const Strings = require('../../../../app/shared/Strings');
const ShortCourseConstants = require('../../../../app/shared/ShortCourseConstants');

const ShortCourseActions = require('../../actions/ShortCourseActions');

const AssetUtil = require('../../util/asset');
import SingleAssetInput from '../common/SingleAssetInput';
import AccessibleIcon from '../common/AccessibleIcon';
import ConfirmModal from '../modal/ConfirmModal';
import CoachConditionsLine from './CoachConditionsLine';

const propTypes = {
    phraseData: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    closeHandler: PropTypes.func.isRequired,
};

const defaultProps = {
};

const NEW_PHRASESET_ID = "new_phrase";

class CoursePhraseSystemEditorModal extends React.Component {
    constructor(props) {
        super(props);
        let phraseData = _.cloneDeep(props.phraseData);
        if (!phraseData.phraseSets) {
            // create blank phraseData
            phraseData = {
                phraseSets: [],
            };
        }
        this.state = {
            phraseData,
            selected_phrase_set_id: "",
        };
    }
    
    /*onTextChange=(key,e)=>{
        this.setState({[key]: e.target.value });
    }*/
    
    save=()=>{
        this.props.onChange(this.state.phraseData);
        this.props.closeHandler();
    }

    onSelectPhraseSet=(e)=>{
        var selected_phrase_set_id = e.target.value;
        if (selected_phrase_set_id === NEW_PHRASESET_ID) {
            let id = 'phraseset-' + uuid.v4();
            let phraseData = {...this.state.phraseData};
            let testIndex = phraseData.phraseSets.length;
            let variableSuffix;
            do {
                testIndex++;
                variableSuffix = "p"+testIndex;
            } while(_.find(phraseData.phraseSets,{variableSuffix}));

            phraseData.phraseSets.push({
                id,
                variableSuffix,
                phrases:[""],
            });
            selected_phrase_set_id = id;
            this.setState({phraseData,selected_phrase_set_id, conditionsExpanded: false});
        }
        else {
            this.setState({selected_phrase_set_id, conditionsExpanded: false});
        }
    }
    
    addPhraseToSelectedSet=()=>{
        let phraseData = {...this.state.phraseData};
        const selectedPhraseEntry = _.find(phraseData.phraseSets,{id:this.state.selected_phrase_set_id});
        if (selectedPhraseEntry) {
            selectedPhraseEntry.phrases.push(""); 
            this.setState({phraseData});
        }
    }
    
    deleteSelectedPhraseSet=()=>{
        this.setState({
            modalConfirm: {
                modalTitle: "Confirm Delete Phrase Set",
                text: Strings['en'].short_course.modals.phrase_system.CONFIRM_DELETE_PHRASE_SET,
                confirmHandler: ()=>{
                    let phraseData = {...this.state.phraseData};
                    const selectedPhraseEntry = _.find(phraseData.phraseSets,{id:this.state.selected_phrase_set_id});
                    if (selectedPhraseEntry) {
                        phraseData.phraseSets = _.without(phraseData.phraseSets,selectedPhraseEntry);
                        this.setState({
                            phraseData, selected_phrase_set_id:'',
                            modalConfirm: null
                        });
                    }
                    else {
                        this.setState({modalConfirm: null});
                    }
                },
                cancelHandler: ()=>{
                    this.setState({modalConfirm: null})
                },

            }
        });
    }
    
    onPhraseChange=(i,e)=>{
        let phraseData = {...this.state.phraseData};
        let selectedPhraseEntry = _.find(phraseData.phraseSets,{id:this.state.selected_phrase_set_id});
        if (selectedPhraseEntry) {
            selectedPhraseEntry.phrases[i] = e.target.value;
            this.setState({phraseData});
        }
    }
    
    onPhraseDelete=(i,e)=>{
        let phraseData = {...this.state.phraseData};
        let selectedPhraseEntry = _.find(phraseData.phraseSets,{id:this.state.selected_phrase_set_id});
        if (selectedPhraseEntry) {
            selectedPhraseEntry.phrases.splice(i,1);
            this.setState({phraseData});
        }
    }
    
    onVariableSuffixChange=(e)=>{
        let phraseData = {...this.state.phraseData};
        let selectedPhraseEntry = _.find(phraseData.phraseSets,{id:this.state.selected_phrase_set_id});
        if (selectedPhraseEntry) {
            selectedPhraseEntry.variableSuffix = e.target.value;
            this.setState({phraseData});
        }
    }
    
    onConditionsChange=(conditions)=>{
        let phraseData = {...this.state.phraseData};
        let selectedPhraseEntry = _.find(phraseData.phraseSets,{id:this.state.selected_phrase_set_id});
        if (selectedPhraseEntry) {
            selectedPhraseEntry.conditions = conditions;
            this.setState({phraseData});
        }
    }
    
    toggleConditionsExpanded=()=>{
        let conditionsExpanded  = !this.state.conditionsExpanded;
        this.setState({conditionsExpanded});
    }
    
    closeHandler=()=>{
        const same = _.isEqual(this.state.phraseData,this.props.phraseData);
        if (same) {
            this.props.closeHandler();
        }
        else {
            this.setState({
                modalConfirm: {
                    modalTitle: "Confirm Exit",
                    text: Strings['en'].short_course.modals.phrase_system.EXIT_WITHOUT_SAVING,
                    confirmHandler: ()=>{
                        this.setState({modalConfirm: null},()=>{
                            this.props.closeHandler();
                        });
                    },
                    cancelHandler: ()=>{
                        this.setState({modalConfirm: null})
                    },

                }
            });
        }
    }
    
    render() {
        const phraseData = this.state.phraseData;
        const selected_phrase_set_id = this.state.selected_phrase_set_id;
        const selectedPhraseEntry = _.find(phraseData.phraseSets,{id:selected_phrase_set_id});
        let suffixError;
        if (selectedPhraseEntry) {
            let check = _.filter(phraseData.phraseSets,{variableSuffix:selectedPhraseEntry.variableSuffix});
            if (check.length > 1) {
                suffixError = 'duplicate suffix'; 
            }
            else {
                if (selectedPhraseEntry.variableSuffix.match(/[^\w\.\-]/) !== null) {
                    suffixError = "suffix should be alphanumeric with no spaces";
                }
            }
        }
        
        if (this.state.modalConfirm) {
            let { modalTitle, text, confirmHandler, cancelHandler } = this.state.modalConfirm;
            return (
                <ConfirmModal key="confirmModal"
                    theme="new"
                    show={true}
                    modalTitle={modalTitle}
                    text={text}
                    buttonText={"confirm"}
                    confirmHandler={confirmHandler}
                    cancelButtonText={"cancel"}
                    cancelHandler={cancelHandler}
                    closeHandler={cancelHandler}
                    confirmButtonBsStyle="info"
                    cancelButtonBsStyle="info"
                    enforceFocus
                    restoreFocus
                    backdrop
                />
            );
        }
        
        return (
            <Modal
                key="mainModal"
                dialogClassName="course-phrase-system-modal"
                show={true}
                keyboard
                autoFocus
                enforceFocus={false}
                restoreFocus={false}
                backdrop={false}
                animation={false}
                onHide={null}
                aria-labelledby="phrase-system-title"
            >
                <Modal.Header closeButton closeLabel={Strings['en'].common.CLOSE} onHide={this.closeHandler}>
                    <Modal.Title id="phrase-system-title">{Strings['en'].short_course.modals.phrase_system.MODAL_HEADER}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="phrase-system-body">
                        <div className="edit-selector">
                            <label>{Strings['en'].short_course.modals.phrase_system.SELECT_PHRASE_SET  + ':'}</label>
                            <select value={selected_phrase_set_id} onChange={this.onSelectPhraseSet}>
                                <option value={''} disabled>{'Select...'}</option>
                        { _.map(phraseData.phraseSets,(phraseEntry,index)=>{
                            let check = _.filter(phraseData.phraseSets,{variableSuffix:phraseEntry.variableSuffix});
                            let hasProblem = (check.length > 1);
                            return (
                                <option key={index} className={hasProblem ? "error-text" : ""} value={phraseEntry.id}>
                                    {`{${ShortCourseConstants.PHRASE_VARIABLE_PREFIX + phraseEntry.variableSuffix}}`}
                                </option>
                            )
                        })}
                                <option key={"new-phraseset"} value={NEW_PHRASESET_ID}>
                                    {`Add new phrase set`}
                                </option>
                            </select>
                        </div>
                        {selectedPhraseEntry ? 
                        <div className="selected-phrase-set-section">
                            <div>
                                <label>{Strings['en'].short_course.modals.phrase_system.PHRASE_VARIABLE_SUFFIX}</label>
                                <input type='text'
                                    className={suffixError ? "error-text" : ""} 
                                    value={selectedPhraseEntry.variableSuffix} 
                                    onChange={this.onVariableSuffixChange}/>
                                { suffixError ? <span className="suffix-error error-text">{suffixError}</span> : null}
                            </div>
                            <div>
                                <CoachConditionsLine 
                                    conditions={selectedPhraseEntry.conditions}
                                    onChangeConditions={this.onConditionsChange}
                                    expanded={this.state.conditionsExpanded}
                                    toggleExpanded={this.toggleConditionsExpanded}
                                />
                            </div>
                            <h2>{Strings['en'].short_course.modals.phrase_system.PHRASES_IN_THIS_SET}</h2>
                            {_.map(selectedPhraseEntry.phrases,(phrase,i)=>(
                                <div className="phrase-row" key={i}>
                                    <input type='text' className="phrase-text" value={phrase} onChange={this.onPhraseChange.bind(this,i)}/>
                                    <button title="delete phrase" onClick={this.onPhraseDelete.bind(this,i)}>
                                        <AccessibleIcon className="fa fa-trash" label="delete phrase"/>
                                    </button>
                                </div>
                            ))}
                            <Button onClick={this.addPhraseToSelectedSet} title={Strings['en'].short_course.modals.phrase_system.ADD_PHRASE_TO_SET}>
                                <AccessibleIcon className="fa fa-plus" label={Strings['en'].short_course.modals.phrase_system.ADD_PHRASE_TO_SET} />
                            </Button>
                            <div>
                                <Button title={Strings['en'].common.ADD} onClick={this.deleteSelectedPhraseSet}>
                                    {Strings['en'].short_course.modals.phrase_system.DELETE_PHRASE_SET}
                                </Button>
                            </div>
                        </div>
                        : null }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary update-button" title={Strings['en'].common.UPDATE} disabled={false} onClick={this.save}>
                        {Strings['en'].common.UPDATE}
                    </button>
                </Modal.Footer>
            </Modal>
        );
    } // render
}; // CoursePhraseSystemEditorModal

CoursePhraseSystemEditorModal.propTypes = propTypes;
CoursePhraseSystemEditorModal.defaultProps = defaultProps;

export default CoursePhraseSystemEditorModal;